import { requestInterceptor } from "frontend-auth";
import axios from "axios";

const hseAxiosInstance = axios.create({
    baseURL: "/hse-api",
});
const adminAxiosInstance = axios.create({
    baseURL: "/api",
});
const taskAxiosInstance = axios.create({
    baseURL: "/task-api",
});

hseAxiosInstance.interceptors.request.use(requestInterceptor);
adminAxiosInstance.interceptors.request.use(requestInterceptor);
taskAxiosInstance.interceptors.request.use(requestInterceptor);

export { hseAxiosInstance, adminAxiosInstance, taskAxiosInstance };
